import styled from 'styled-components';

const CompactGrid = styled.div`
  display: grid;
  grid-auto-rows: auto;
`;

const CompactBanner = styled.div`
  display: grid;
  align-content: center;
  justify-content: center;
  height: 200px;
  font-size: 26px;
  font-weight: bold;
`;

const CompactContent = styled.div``;

export { CompactGrid, CompactContent, CompactBanner };



// WEBPACK FOOTER //
// ./src/components/UI/CompactUI.tsx